import React from 'react';
import IsValid from '@components/CustomCell/IsValid';
import ValidationMessage from '@components/CustomCell/ValidationMessage';

export type ColumnName = 'VALID' | 'VALIDATION_MESSAGE';
type CustomComponent = (...args: any) => React.ReactNode;

const customCellsDefinition: { [columnName in ColumnName]: CustomComponent } = {
  VALID: (rowValues: any) => {
    const { VALID } = rowValues;
    return <IsValid isValid={VALID} />;
  },
  VALIDATION_MESSAGE: (rowValues: any) => {
    const { VALIDATION_MESSAGE_JSON, VALIDATION_MESSAGE } = rowValues;
    return (
      <ValidationMessage
        validationMessageOld={VALIDATION_MESSAGE}
        validationMessageJson={VALIDATION_MESSAGE_JSON}
      />
    );
  },
};

export default customCellsDefinition;
